import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import { getPrintFieldNames } from "../../../utils/getPrintFieldNames";

export const printFieldsModal = ({
  t,
  modalData,
  windowValues,
  setWindowValues,
  closeMsg,
}: stdObject) => {
  return {
    title: t("p.fields"),
    table: modalData.printCode
      ? modalData.totalFields.map((v: stdObject, index: number) => {
          return {
            data: [v.label ?? getPrintFieldNames(t, v.code)],
            style: {
              backgroundColor: !!windowValues.printFields?.[index]
                ? colors.lightGreen2
                : colors.white,
            },
            onClick: () => {
              let tempValues = windowValues;
              tempValues.printFields[index] = !!tempValues.printFields[index]
                ? null
                : v;
              setWindowValues({ ...tempValues });
            },
          };
        })
      : [],
    buttons: [
      {
        label: t("p.print"),
        onClick: () =>
          modalData.printList(modalData.printCode, 2, windowValues),
        color: colors.blue,
      },
      {
        label: "XLS",
        onClick: () =>
          modalData.printList(modalData.printCode, 3, windowValues),
        color: colors.green,
      },
      modalData.printCode === "ART" && {
        label: t("p.tickets"),
        onClick: () => modalData.printTickets(),
        color: colors.orange,
      },
      {
        label: t("p.cancel"),
        onClick: closeMsg,
        color: colors.darkGrey,
      },
    ],
  };
};
